import React from 'react';
import { Drawer } from 'antd';
import { DSIcon } from '../atoms';

const CustomDrawer = ({
  visible,
  title,
  subHeaderStyle,
  headerStyle,
  width,
  close,
  body,
}) => {
  return (
    <Drawer
      title={
        <div style={subHeaderStyle}>
          {title}
          <button
            type='button'
            aria-label='Close drawer'
            onClick={close}
            className='inline-flex h-10 w-10 items-center justify-center rounded-ds-md border border-gray-300 bg-white text-gray-500 transition-colors duration-150 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-ds-brand focus:ring-offset-2'
          >
            <DSIcon name='close' size={16} />
          </button>
        </div>
      }
      visible={visible}
      width={width}
      headerStyle={headerStyle}
      onClose={close}
      drawerStyle={{'overflow-x': 'hidden'}}
      className='help-drawer-xs'
    >
      {body}
    </Drawer>
  );
};

export default CustomDrawer;
